module.exports = __webpack_public_path__ + "static/schaukel06-db1eead5bde5fa5d0d74b154425613d9.jpg";